module.exports = __webpack_public_path__ + "static/img/16areaB_1.afd3004.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/16areaB_1.png
// module id = 1130
// module chunks = 1